import React from 'react'
import {Alert} from 'react-bootstrap'
import {Variant} from 'react-bootstrap/esm/types'

/**
 * `CustomAlert` es un componente funcional de React que muestra mensajes de alerta personalizables
 * utilizando el componente `Alert` de `react-bootstrap`.
 * 
 * @param {ICustomAlert} props - Las propiedades del componente.
 * @param {boolean} props.show - Determina si el mensaje de alerta debe mostrarse o no.
 * @param {string} [props.title] - Título del mensaje de alerta.
 * @param {string} [props.text] - Texto o contenido del mensaje de alerta.
 * @param {string} [props.className] - Clases CSS adicionales para estilizar el contenedor del mensaje de alerta.
 * @param {Variant} props.variant - El estilo visual del mensaje de alerta, basado en variantes de `react-bootstrap` como `success`, `danger`, `warning`, etc.
 * @param {() => void} [props.close] - Función opcional que se invoca al cerrar la alerta.
 * @returns {React.FC<ICustomAlert>} Un componente funcional de React que muestra un mensaje de alerta configurable.
 * 
 * @example
 * // Ejemplo de cómo mostrar una alerta con un mensaje informativo:
 * <CustomAlert
 *   show={true}
 *   title="Error"
 *   text="Este es un mensaje de error."
 *   variant="danger"
 *   close={() => console.log('Alerta cerrada')}
 * />
 */

interface ICustomAlert {
  show: boolean
  title?: string
  text?: string
  className?: string
  variant: Variant
  close?: () => void
}

const CustomAlert = ({show, title, text, className, variant, close}: ICustomAlert) => {
  return (
    <>
      {show && (
        <Alert variant={variant} className={`mb-4 mt-2 ${className}`} onClose={close} dismissible>
          {title && <h2 className='alert-heading'>{title || ''}</h2>}
          <p className='fw-semibold'>{text || ''}</p>
        </Alert>
      )}
    </>
  )
}

export default CustomAlert
